import script from "./ShipToUser.vue?vue&type=script&setup=true&lang=js"
export * from "./ShipToUser.vue?vue&type=script&setup=true&lang=js"

import "./ShipToUser.vue?vue&type=style&index=0&id=ddbd84f0&lang=scss"

const __exports__ = script;

export default __exports__